export enum NotificationTypeEnum {
    Recordables = 1,
    ChangeOrder = 2
}